import React from 'react'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiX } = FiIcons

const RequestLogsModal = ({ isOpen, onClose, logs }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-40" onClick={onClose}></div>
      <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-lg w-full mx-4 p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Link Requests</h3>
          <button className="no-border" onClick={onClose} aria-label="Close">
            <SafeIcon icon={FiX} className="w-5 h-5 text-gray-600 dark:text-gray-300" />
          </button>
        </div>
        <div className="space-y-2 max-h-80 overflow-y-auto">
          {(logs || []).map((entry, idx) => (
            <div key={idx} className="p-2 rounded border border-gray-200 dark:border-gray-700">
              <div className="text-sm text-gray-600 dark:text-gray-300">{new Date(entry.sent_at).toLocaleString()}</div>
              <div className="text-sm text-gray-700 dark:text-gray-200">{entry.subject}</div>
            </div>
          ))}
          {!((logs || []).length) && (
            <div className="text-sm text-gray-600 dark:text-gray-300">No requests yet.</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RequestLogsModal